import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4bafe70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "switch-slider" }

import Icon from '@/components/icon/Icon.vue';
import { useLayout } from '@/store/modules/layout/useLayout';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ThemeSwitch',
  setup(__props) {

const theme = computed(() => useLayout().theme);
const { switchTheme } = useLayout();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["theme-switch", _unref(theme)]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(switchTheme) && _unref(switchTheme)(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Icon, {
          name: `${_unref(theme)}Theme`,
          size: "16"
        }, null, 8, ["name"])
      ])
    ], 2)
  ]))
}
}

})